<template>
  <div class="security-code">
    <base-heading underline>
      {{ $t('userAccount.securityCode.pageTitle') }}
    </base-heading>
    <p>{{ $t('userAccount.securityCode.deactivateCodeDescription') }}</p>
    <validation-observer ref="securityCodeObs"
                         tag="form"
                         class="code-form"
                         v-slot="{ errors }"
                         @submit.prevent="deactivateSecurityCode">
      <label for="security-1" class="code-label">{{ $t('userAccount.securityCode.enterCodeLabel') }}</label>
      <div class="code-inputs-wrapper">
        <validation-provider v-for="index in inputFieldsCount"
                             :key="'provider'+index"
                             tag="div"
                             class="code-input"
                             :mode="formSubmitted ? 'eager' : 'passive'"
                             v-slot="{ errors }"
                             :vid="'security-'+index"
                             rules="required|numeric|max:1">
          <base-input v-model="securityCode[index - 1]"
                      variant="center-grey"
                      :invalid="!!errors.length"
                      maxlength="1"
                      :ref="'input'+index"
                      :id="'security-'+index"
                      :name="'security-'+index"
                      @input="handleCodeInput(index, $event)"/>
        </validation-provider>
      </div>
      <p class="error-msg" v-html="formSubmitted && isFormInvalid(errors) ? $t('userAccount.securityCode.deactivateInvalidCodeError') : '&nbsp;'"></p>
      <div class="action-button-wrapper">
        <base-button type="submit"
                     variant="primary"
                     ref="submitBtn"
                     :disabled="enteredCode.length < 6 || dataLoading || formInvalid">
          {{ $t('common.deactivate') }}
        </base-button>
      </div>
    </validation-observer>

    <modal size="lg"
           class="confirmation-modal"
           :visible="confirmationModalVisible"
           :closeButtonVisible="false"
           :key="'confirmationModal'"
           @modal-close="closeConfirmationModal">
      <img src="/assets/images/delete-warning.svg" class="modal-icon" alt=""/>
      <h2 class="title">{{ $t('userAccount.securityCode.confirmationModalTitle') }}</h2>
      <div class="action-buttons">
        <base-button variant="primary" :disabled="dataLoading" @click="sendCodeDeactivationRequest">{{ $t('common.deactivate') }}</base-button>
        <base-button class="cancel-btn" variant="text" @click="closeConfirmationModal">{{ $t('common.cancel') }}</base-button>
      </div>
    </modal>
  </div>
</template>

<script>
import errorMessageHandler from '@/mixins/errorMessageHandler'
import logout from '@/mixins/logout'
import Modal from '@/components/common/modal/modal'
import codeInput from '@/mixins/codeInput'

export default {
  name: 'user-deactivate-security-code',
  components: { Modal },
  data () {
    return {
      inputFieldsCount: 6,
      securityCode: [],
      formSubmitted: false,
      dataLoading: false,
      confirmationModalVisible: false,
      formInvalid: false
    }
  },
  mixins: [errorMessageHandler, logout, codeInput],
  computed: {
    enteredCode () {
      return this.securityCode.join('')
    }
  },
  methods: {
    async deactivateSecurityCode () {
      const formValid = await this.$refs.securityCodeObs.validate()
      this.formSubmitted = true

      if (formValid) {
        this.openDeactivationCodeConfirmation()
      }
    },
    openDeactivationCodeConfirmation () {
      this.confirmationModalVisible = true
    },
    closeConfirmationModal () {
      this.confirmationModalVisible = false
    },
    sendCodeDeactivationRequest () {
      this.dataLoading = true
      this.$apiRequest.delete('user/securitycode', { data: { code: this.enteredCode } })
        .then(response => {
          this.toast('success', {
            message: this.$t('userAccount.securityCode.deactivateCodeSuccessMessage')
          })
          setTimeout(() => {
            this.logoutUser()
          }, 3000)
        })
        .catch(e => {
          // set errors to all input fields
          const errorsObj = {}
          Object.keys(this.$refs.securityCodeObs.fields).forEach(key => {
            errorsObj[key] = 'error'
          })
          this.$refs.securityCodeObs.setErrors(errorsObj)
          this.formInvalid = true
          this.dataLoading = false
        })
        .finally(() => {
          this.closeConfirmationModal()
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      const firstInput = this.getRefElement(this.$refs.input1).$refs.input
      firstInput.addEventListener('paste', this.handleKeyboardPaste)
    })
  },
  beforeDestroy () {
    const firstInput = this.getRefElement(this.$refs.input1).$refs.input
    firstInput.removeEventListener('paste', this.handleKeyboardPaste)
  }
}
</script>

<style scoped lang="scss" src="./styles/security-code.scss"></style>
